import { render, staticRenderFns } from "./InventoryReservationEdit.vue?vue&type=template&id=65b8f884"
import script from "./InventoryReservationEdit.vue?vue&type=script&lang=js"
export * from "./InventoryReservationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports